 @if(cardData.isRecommeded){<span class="recommen">RECOMMENDED</span>}
<div class="card-section card" [class.selected]="isSelected">
    <div class="card-header">
         <h3><b>{{cardData.title}}</b></h3>
         
    </div>
    <p [innerHTML]="cardData.cardText"></p>
</div>